export const columns = [

  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '标题',
    dataIndex: 'name',
  },
  {
    title: '是否医生',
    dataIndex: 'admin_type',
    scopedSlots: { customRender: 'admin_type' },
  },
  {
    title: '作者',
    dataIndex: 'admin_name',
  },
  {
    title: '点击量',
    dataIndex: 'hits',
  },
  {
    title: '点赞',
    dataIndex: 'likes',
    scopedSlots: { customRender: 'likes' },
    width: 100,
  },
  {
    title: '收藏',
    dataIndex: 'favorites',
    scopedSlots: { customRender: 'favorites' },
    width: 100,
  },
  {
    title: '视频',
    dataIndex: 'video',
    scopedSlots: { customRender: 'video' },
    width: 100,
  },
  {
    title: '更新时间',
    dataIndex: 'update_time',
  },
  {
    title: '发布时间',
    dataIndex: 'create_time',
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    fixed: 'right',
    width: 200,
  },
];

export const formData = [
  {
    name: 'company_id',
    lable: '选择企业',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'group_id',
    lable: '选择栏目',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'name',
    lable: '标题',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'post_excerpt',
    lable: '摘要',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'list_order',
    lable: '排序',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'speaker',
    lable: '主讲人',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'video_id',
    lable: '上传视频',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'video_time',
    lable: '视频时长',
    lableCol: 3,
    wrapperCol: 18,
  },
  {
    name: 'post_content',
    lable: '内容',
    lableCol: 3,
    wrapperCol: 18,
  },
];